import { toast as sonnerToast } from "sonner";

type ToastProps = {
  title?: string;
  description?: string;
  variant?: "default" | "success" | "error" | "warning" | "info" | "destructive";
  action?: React.ReactNode;
  duration?: number;
};

function toast(props: ToastProps) {
  const { title, description, variant, duration } = props;
  const message = title || description || "";
  const baseOptions = title && description ? { description } : {};
  const options = duration !== undefined ? { ...baseOptions, duration } : (Object.keys(baseOptions).length > 0 ? baseOptions : undefined);

  switch (variant) {
    case "destructive":
    case "error":
      return sonnerToast.error(message, options);
    case "success":
      return sonnerToast.success(message, options);
    case "warning":
      return sonnerToast.warning(message, options);
    case "info":
      return sonnerToast.info(message, options);
    default:
      return sonnerToast(message, options);
  }
}

toast.success = (props: Omit<ToastProps, "variant">) => toast({ ...props, variant: "success" });
toast.error = (props: Omit<ToastProps, "variant">) => toast({ ...props, variant: "error" });
toast.warning = (props: Omit<ToastProps, "variant">) => toast({ ...props, variant: "warning" });
toast.info = (props: Omit<ToastProps, "variant">) => toast({ ...props, variant: "info" });

function useToast() {
  return {
    toast,
    dismiss: (toastId?: string | number) => sonnerToast.dismiss(toastId),
  };
}

export { useToast, toast };
